import { render, staticRenderFns } from "./tjzbhxr.vue?vue&type=template&id=a1b7585c"
import script from "./tjzbhxr.vue?vue&type=script&lang=js"
export * from "./tjzbhxr.vue?vue&type=script&lang=js"
import style0 from "./tjzbhxr.vue?vue&type=style&index=0&id=a1b7585c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports